
import { defineComponent, Ref, ref, computed } from 'vue'
import ContainerTypeBadge from "@/view/pages/vesselMonitoring/components/ContainerTypeBadge.vue"
import VesselMonitoringSingleHatch from "./VesselMonitoringSingleHatch.vue"
import { mapGetters } from "vuex"

interface MonitoringBayData {
  id: number
  vesselName: string
  bay: string
  dock: string
  view: string
  containerType: string
  containerColor: string
}

interface Cell {
  existed: boolean
  isReefer: boolean
  is45Foot: boolean
  isTank: boolean
  isFlatRack: boolean
  isOpenTop: boolean
  isPlatform: boolean
}

export default defineComponent({
  components: {
    ContainerTypeBadge,
    VesselMonitoringSingleHatch
  },

  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    vesselMonitoringData() {
      return this.getVesselMonitoringData
    }
  }
});

